// extracted by mini-css-extract-plugin
export default {"popup":"SelectPlatform_popup__VJ1yQ","button":"SelectPlatform_button__zrkeP"};